<div class="validate-response-wrap">
  <div class="validate-block">
    <div class="d-flex align-items-center justify-space-between">
      <div>
        <div class="validate-title">
          {{ "VALIDATE_RESPONSE.CORRECT_ANSWERS" | translate }}
        </div>
        <div class="validate-subtitle">
          {{ "VALIDATE_RESPONSE.CORRECT_ANSWERS_SUBTITLE" | translate }}
        </div>
      </div>
      <mat-slide-toggle
        [(ngModel)]="isCorrectAnswersVisible"
        labelPosition="before"
      ></mat-slide-toggle>
    </div>
  </div>
  @if (isCorrectAnswersVisible) {
    <div class="divider"></div>
  }
  @if (isCorrectAnswersVisible && type === scenarioItemType.POLL) {
    <div
      class="validate-block content"
      >
      @if (type === scenarioItemType.POLL) {
        <div class="content-section">
          <div class="block-title">
            {{ "VALIDATE_RESPONSE.CORRECT_ANSWERS" | translate }}
          </div>
          <div class="correct-options">
            <label class="poll-option">
              <input
                type="radio"
                class="poll-radio"
                name="poll-correct"
                value="1"
                [(ngModel)]="correct_answer"
                />
              <span class="poll-label">{{
                "VALIDATE_RESPONSE.YES" | translate
              }}</span>
            </label>
            <label class="poll-option">
              <input
                type="radio"
                class="poll-radio"
                name="poll-correct"
                value="0"
                [(ngModel)]="correct_answer"
                />
              <span class="poll-label">{{
                "VALIDATE_RESPONSE.NO" | translate
              }}</span>
            </label>
          </div>
        </div>
      }
    </div>
  }
  @if (isCorrectAnswersVisible) {
    <div class="validate-block content">
      @if (type === scenarioItemType.MULTI_CHOICE) {
        <div class="content-section">
          <div class="block-title">
            {{ "VALIDATE_RESPONSE.CORRECT_ANSWERS" | translate }}
          </div>
        </div>
      }
      @if (type === scenarioItemType.MULTI_CHOICE && options?.length) {
        <div
          class="mt-16 options-container"
          >
          @if (maxSelectedAnswers) {
            <span class="text-warning"
              >Please choose {{ maxSelectedAnswers }} option{{
              maxSelectedAnswers > 1 ? "s" : ""
              }}</span
              >
            }
            @for (option of options; track option; let i = $index) {
              <div class="option-item">
                <input
                  type="checkbox"
                  class="option-checkbox"
                  [id]="'option-' + (option.id || i)"
                  [checked]="option.is_correct"
                  (change)="toggleOption(i, $event.target.checked)"
                  />
                <label [for]="'option-' + (option.id || i)" class="option-label">
                  {{ getOptionText(option) }}
                </label>
              </div>
            }
          </div>
        }
        @if (type === scenarioItemType.LINEAR) {
          <div
            class="linear-inputs-container"
            >
            <div class="content-section w-100">
              <div class="content-label-wrapper">
                <div class="block-title">
                  {{ "VALIDATE_RESPONSE.CORRECT_ANSWERS" | translate }}
                </div>
              </div>
              <div class="content-input-wrapper">
                <input
                  type="number"
                  class="content-input"
                  [(ngModel)]="correct_answer"
                  min="0"
                  />
              </div>
            </div>
          </div>
        }
        <div class="content-section">
          <div class="content-label-wrapper">
            <div class="block-title">
              {{ "VALIDATE_RESPONSE.MAX_SCORE" | translate }}
            </div>
            <div class="validate-subtitle">
              {{ "VALIDATE_RESPONSE.MAX_SCORE_SUBTITLE" | translate }}
            </div>
          </div>
          <div class="content-input-wrapper">
            <input
              type="number"
              class="content-input"
              [(ngModel)]="max_score"
              min="0"
              />
          </div>
        </div>
        <div class="content-section">
          <div class="content-label-wrapper">
            <div class="block-title">
              {{ "VALIDATE_RESPONSE.PENALTY_MODIFIER" | translate }}
            </div>
            <div class="validate-subtitle">
              {{ "VALIDATE_RESPONSE.PENALTY_MODIFIER_SUBTITLE" | translate }}
            </div>
          </div>
          <div class="content-input-wrapper">
            <input
              type="number"
              class="content-input"
              [(ngModel)]="penalty_modifier"
              min="1"
              />
          </div>
        </div>
        <div class="content-section">
          <div class="content-checkbox-wrapper">
            <input
              type="checkbox"
              class="content-checkbox"
              [(ngModel)]="auto_send_next_item"
              id="autoAdvance"
              />
            <label for="autoAdvance" class="block-title">
              {{ "VALIDATE_RESPONSE.AUTO_ADVANCE_ON_CORRECT_RESPONSE" | translate }}
            </label>
          </div>
        </div>
        @if (auto_send_next_item) {
          <div class="content-section">
            <div class="content-label-wrapper">
              <div class="block-title">
                {{ "VALIDATE_RESPONSE.AUTO_ADVANCE_DELAY" | translate }}
              </div>
              <div class="validate-subtitle">
                {{ "VALIDATE_RESPONSE.AUTO_ADVANCE_DELAY_SUBTITLE" | translate }}
              </div>
            </div>
            <div class="content-input-wrapper">
              <input
                type="number"
                class="content-input"
                [(ngModel)]="auto_send_next_item_delay"
                min="0"
                max="60"
                />
            </div>
          </div>
        }
      </div>
    }
  </div>
